export const getItemPath = path =>
  [path.split('.')[0], path.split('.')[1]].join('.')

export * from './recipeBatchSize'
export * from './recipeWeight'
export * from './recipeCost'
export * from './recipeNutritionalValues'
export * from './recipeKitchens'
export * from './formatRecipesToSimulate'
